module.exports = __WEBPACK_EXTERNAL_MODULE__ethereumjs_trie__;